import type { RelevancyCardProps } from '../DynamicCardComponent';

import SandEComponent from './SandEComponent';

import { getArticleUrl } from '@services/LinkRuleService';

const trackingData = {
  name: 'Podcast',
  category: 'sponsored card',
};

export const AudioComponent = (props: RelevancyCardProps) => {
  const {
    item: { teaser },
  } = props;

  return (
    <SandEComponent
      {...props}
      trackArticleId
      fetchArticle={!props?.item?.teaser}
      cardType='podcast'
      buttonTag='listen-now'
      logoByLanguage={false}
      showTitle={false}
      target='_blank'
      url={getArticleUrl(teaser.id)}
      trackingData={trackingData}
    />
  );
};

export default AudioComponent;
